import listSaga from './listSaga'
import createSaga from './createSaga'
import editSaga from './editSaga'
import deleteSaga from './deleteSaga'
import oneGroupSaga from './oneGroup'
const groupSaga = [listSaga(), createSaga(), editSaga(), deleteSaga(), oneGroupSaga()]

export default groupSaga
